module.exports = __webpack_public_path__ + "img/logo_2020.0b41df77.png";